import { render, staticRenderFns } from "./pix-card.vue?vue&type=template&id=b8ad3e0a&scoped=true&"
import script from "./pix-card.vue?vue&type=script&lang=js&"
export * from "./pix-card.vue?vue&type=script&lang=js&"
import style0 from "./pix-card.vue?vue&type=style&index=0&id=b8ad3e0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ad3e0a",
  null
  
)

export default component.exports